import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";

import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import {useHistory, useParams} from "react-router-dom";
import MenuWithDrawer from "../../components/app/layout/menuWithDrawer/menuWithDrawer";
import SkeletonLoaderWrapper from "../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper.jsx";
import { muiDatePickersLocales } from "../../helpers/mui/muiLocales";
import { getRouteUrl } from "../../helpers/routing/getRouteUrl";
import useUserAction from "../../hooks/user/useUserAction";

import useUserData from "../../hooks/user/useUserData";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
import { ROUTE_CHANGE_PASSWORD, ROUTE_PAGE_LOGIN } from "../../routers/routes";

import UnauthenticatedRouter from "../../routers/unauthenticatedRouter.jsx";
import Content from "./content.jsx";
import 'dayjs/locale/el'

const Main = () => {
	const {campaign} = useParams()
	const { isLoggedIn, language, loading, message } = useUserData()
	const history = useHistory();
	const { t } = useTranslation(PAGE_LOGIN)
	dayjs.locale(language);
	const { getUserPermissions, getUserDetails, setUserMessage } = useUserAction()

	// useEffect(() => {
	// 	if (isLoggedIn) {
	// 		// getUserPermissions()
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [isLoggedIn])
	
	// useEffect(() => {
	// 	if (isLoggedIn) {
	// 		// getUserDetails() //TODO::Uncomment when API is ready
	// 	}
	// }, [getUserDetails, isLoggedIn])
	
	useEffect(() => {
		if (message) {
			enqueueSnackbar(t(message?.text), {
					variant: message?.variant,
					autoHideDuration: 1000
				}
			)
			setUserMessage(null)
		}
	}, [message, setUserMessage, t])
	
	useEffect(() => {
		if (!isLoggedIn) {
			history.push(getRouteUrl(ROUTE_PAGE_LOGIN,{campaign}));
		}
	}, [isLoggedIn, history]);
	
	if (!isLoggedIn) return (
		<LocalizationProvider
			dateAdapter={AdapterDayjs}
			localeText={muiDatePickersLocales(language)}
		>
			{/*You can wrap unauthenticated routes with a custom app layout if necessary. i.e. your unauthenticated pages have the same header, footer etc */}
			<MenuWithDrawer>
				<UnauthenticatedRouter/>
			</MenuWithDrawer>
		</LocalizationProvider>
	)
	
	return (
		<SkeletonLoaderWrapper loading={loading}>
			<LocalizationProvider
				dateAdapter={AdapterDayjs}
				localeText={muiDatePickersLocales(language)}
			>
				<Content/>
			</LocalizationProvider>
		</SkeletonLoaderWrapper>
	)
}

export default Main